import 'bootstrap';
import './utils';
import './ajax-form';
import './porto';
import './countdown';
import './theme';
import './theme.init';
import './ad-banners';
import './coming-up-filter';
import './tour-page/all';
import './tour-page/desktop';
import './tour-page/mobile';

import MoEngageConnector from './moengage';
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

// If phone number field exists on the page, load intlTelInput script
if (document.getElementById("phone")) {
	const phoneNumberField = document.getElementById("phone");
	const iti = intlTelInput(phoneNumberField, {
		countryOrder: ["au", "nz"],
		validationNumberType: "PERSONAL_NUMBER",
		separateDialCode: true,
		nationalMode: true,
		strictMode: true,
		onlyCountries: ["au", "nz"],
		useFullscreenPopup: false,
		customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
			let placeholder = "4xx xxx xxx";
			if (selectedCountryData.dialCode == 64) {
				placeholder = "2x xxx xxxx";
			} else if (JSON.stringify(selectedCountryData) == "{}") {
				placeholder = "";
			}
			return placeholder;
		}
	});

	window.iti = iti; // this is exposed in case we need to call it elsewhere in the future
}

window.moEngageVar = new MoEngageConnector();

if (window.__MOENGAGE_DATA__?.moengageOn) {
	moEngageVar.init();
}